<script>
    import { hamburger_menu_open, user_store } from "../stores.js"; 
    import MenuItem from "../components/MenuItem.svelte";
    import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import breakpoints from "./breakpoints";


    let myself = {};
    user_store.subscribe(value => {
        myself = value;
    });

    const bp = breakpoints();

    export let menu_items = [];

    function adjust_menu() {
        $hamburger_menu_open = ($bp === "desktop") ? false: $hamburger_menu_open;
        const status = ($bp === "desktop" || $hamburger_menu_open === true);
        return status;
    }

    $: show_menu = adjust_menu($hamburger_menu_open, $bp);


    onMount(() => {
        resetMenu();
    });

    function resetMenu(){
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        for(let i = 0; i < menu_items.length; i++){
            const mni = menu_items[i];

            mni.is_open = false;
            mni.is_selected = false;
            mni.show_item = true;
            if(mni.m === "submenu" && "sm_items" in mni){
                for(let j = 0; j < mni.sm_items.length; j++){
                    mni.sm_items[j].is_open = false;
                    mni.sm_items[j].is_selected = false;
                    mni.sm_items[j].show_item = false;
                }
            }
        }
    }

    function deselectAll(){
        for(let i = 0; i < menu_items.length; i++){
            const mni = menu_items[i];
            mni.is_selected = false;
            if(mni.m === "submenu" && "sm_items" in mni){
                for(let j = 0; j < mni.sm_items.length; j++){
                    mni.sm_items[j].is_selected = false;
                }
            }
        }
    }

    function doMenuMessage(e) {
        const msg = e.detail;
        if (msg.type === "parent") {
            // if closed, close all other top-level menu items first
            if(!menu_items[msg.index].is_open){
                resetMenu();
                menu_items[msg.index].is_open = true;
            }else{
                menu_items[msg.index].is_open = false;
            }

            if(menu_items[msg.index].m === "submenu" && "sm_items" in menu_items[msg.index]){
                for(let j = 0; j < menu_items[msg.index].sm_items.length; j++){
                    menu_items[msg.index].sm_items[j].show_item = menu_items[msg.index].is_open;
                }
            }

            if(menu_items[msg.index].m === "link"){
                deselectAll();
                menu_items[msg.index].is_selected = true;
                $hamburger_menu_open = false;
            }
        }

        if(msg.type === "child"){
            deselectAll();
            menu_items[parseInt(msg.parent_index)]["sm_items"][parseInt(msg.index)].is_selected = true;
            $hamburger_menu_open = false;
        }

        // in either case, do link
        if(msg.hash_link !== undefined && msg.hash_link.length > 0){
            push(msg.hash_link);
        }
    }

    const get_menu_title = (original_title) => {
        if (myself.plan_type === 'basic') {
            switch (original_title) {
                case 'Jobs':
                    return 'Requests';
                case 'Clients':
                    return 'Leads';
                default:
                    return original_title;
            }
        } else {
            return original_title;
        }
    }

    const is_menu_able = (pt) => {
        if (myself.plan_type === 'basic') {
            if (pt === 1 || pt === 10) {
                return true;
            } else {
                return false;
            }
        } else if (myself.plan_type === 'pro') {
            if (pt === 2 || pt === 1) {
                return true;
            } else {
                return false;
            }
        } else if (myself.plan_type === 'prime' || myself.plan_type === 'free') {
            if (pt === 3 || pt === 2 || pt === 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
</script>


{#each menu_items as next_menu_item, i}
    {#if myself.plan_type && is_menu_able(next_menu_item.pt)}
        {#if !((myself.role === 'manager' || myself.role === 'admin') && (next_menu_item.id === 'accounting' || next_menu_item.id === 'payment_report'))}
            <MenuItem
                type="parent"
                index={i}
                id={next_menu_item.id}
                title={get_menu_title(next_menu_item.t)}
                has_subitems={(next_menu_item.m === "submenu") ? true : false}
                menu_icon={("i" in next_menu_item) ? next_menu_item.i: ""}
                hash_link={("c" in next_menu_item && next_menu_item.m !== "submenu") ? "/"  + next_menu_item.c : ""}
                on:menumessage={doMenuMessage}
                bind:open={next_menu_item.is_open}
                bind:is_selected={next_menu_item.is_selected}
                bind:show_item={next_menu_item.show_item}
            />

            {#if next_menu_item.m === "submenu" && "sm_items" in next_menu_item}
                {#each next_menu_item.sm_items as next_submenu_item,j}
                    {#if is_menu_able(next_submenu_item.pt)}
                        <MenuItem
                            type="child"
                            index={j}
                            parent_index={i}
                            title={get_menu_title(next_submenu_item.t)}
                            is_sub_menu=true
                            hash_link={("c" in next_submenu_item && next_submenu_item.m !== "submenu") ? `/${next_submenu_item.c}${("p" in next_submenu_item) ? "?" + next_submenu_item.p : ""}` : ""}
                            on:menumessage={doMenuMessage}
                            bind:open={next_submenu_item.is_open}
                            bind:is_selected={next_submenu_item.is_selected}
                            bind:show_item={next_submenu_item.show_item}
                        />
                    {/if}
                {/each}
            {/if}
        {/if}
    {/if}
{/each}

<style>

</style>